import { Box, Button, Heading, HStack, VStack } from "@chakra-ui/react";

import { DialogBody, DialogContent } from "@/components/ui/dialog";

type TicketsAddedModalContentProps = {
  ticketsUsed: number;
  prize: string;
  onClose: () => void;
};

export const TicketsAddedModalContent = ({
  ticketsUsed,
  prize,
  onClose,
}: TicketsAddedModalContentProps) => {
  return (
    <DialogContent>
      <DialogBody p={8}>
        <VStack gap={6}>
          <VStack gap={1}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="34"
              height="34"
              viewBox="0 0 34 34"
              fill="none"
            >
              <path
                d="M17 0.75C13.7861 0.75 10.6443 1.70305 7.97199 3.48862C5.29969 5.27419 3.21689 7.81209 1.98696 10.7814C0.757041 13.7507 0.435237 17.018 1.06225 20.1702C1.68926 23.3224 3.23692 26.2179 5.50952 28.4905C7.78213 30.7631 10.6776 32.3107 13.8298 32.9378C16.982 33.5648 20.2493 33.243 23.2186 32.013C26.1879 30.7831 28.7258 28.7003 30.5114 26.028C32.297 23.3557 33.25 20.2139 33.25 17C33.2455 12.6916 31.5319 8.56102 28.4855 5.51454C25.439 2.46806 21.3084 0.75455 17 0.75ZM24.1344 14.1344L15.3844 22.8844C15.2683 23.0006 15.1304 23.0928 14.9787 23.1557C14.8269 23.2186 14.6643 23.251 14.5 23.251C14.3357 23.251 14.1731 23.2186 14.0213 23.1557C13.8696 23.0928 13.7317 23.0006 13.6156 22.8844L9.86563 19.1344C9.63108 18.8998 9.49931 18.5817 9.49931 18.25C9.49931 17.9183 9.63108 17.6002 9.86563 17.3656C10.1002 17.1311 10.4183 16.9993 10.75 16.9993C11.0817 16.9993 11.3998 17.1311 11.6344 17.3656L14.5 20.2328L22.3656 12.3656C22.4818 12.2495 22.6196 12.1574 22.7714 12.0945C22.9231 12.0317 23.0858 11.9993 23.25 11.9993C23.4143 11.9993 23.5769 12.0317 23.7286 12.0945C23.8804 12.1574 24.0182 12.2495 24.1344 12.3656C24.2505 12.4818 24.3426 12.6196 24.4055 12.7714C24.4684 12.9231 24.5007 13.0858 24.5007 13.25C24.5007 13.4142 24.4684 13.5769 24.4055 13.7286C24.3426 13.8804 24.2505 14.0182 24.1344 14.1344Z"
                fill="#1BA27A"
              />
            </svg>
            <Heading fontSize="40px" fontWeight="bold" lineHeight="48px">
              Tickets Added
            </Heading>
            <Heading
              fontSize="lg"
              fontWeight="500"
              lineHeight="24px"
              textAlign="center"
              color="text.secondary"
            >
              {prize}
            </Heading>
          </VStack>
          <HStack
            px={6}
            py={4}
            bg="rgba(181, 169, 255, 0.20)"
            rounded="2xl"
            w="full"
            justifyContent="space-between"
          >
            <Heading fontSize="xl" fontWeight="bold" color="brandIndigo">
              +{ticketsUsed} Ticket{ticketsUsed > 1 ? "s" : ""}
            </Heading>
            <Box bg="#896EFD" rounded="xl" p={"7.5px"}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="26"
                height="26"
                viewBox="0 0 26 26"
                fill="none"
              >
                <path
                  d="M23.1562 10.6562C23.3635 10.6562 23.5622 10.5739 23.7087 10.4274C23.8552 10.2809 23.9375 10.0822 23.9375 9.875V6.75C23.9375 6.3356 23.7729 5.93817 23.4799 5.64515C23.1868 5.35212 22.7894 5.1875 22.375 5.1875L3.625 5.1875C3.2106 5.1875 2.81317 5.35212 2.52015 5.64515C2.22712 5.93817 2.0625 6.3356 2.0625 6.75L2.0625 9.875C2.0625 10.0822 2.14481 10.2809 2.29132 10.4274C2.43784 10.5739 2.63655 10.6562 2.84375 10.6562C3.46535 10.6562 4.06149 10.9032 4.50103 11.3427C4.94057 11.7823 5.1875 12.3784 5.1875 13C5.1875 13.6216 4.94057 14.2177 4.50103 14.6573C4.06149 15.0968 3.46535 15.3438 2.84375 15.3438C2.63655 15.3438 2.43784 15.4261 2.29132 15.5726C2.14481 15.7191 2.0625 15.9178 2.0625 16.125L2.0625 19.25C2.0625 19.6644 2.22712 20.0618 2.52015 20.3549C2.81317 20.6479 3.2106 20.8125 3.625 20.8125H22.375C22.7894 20.8125 23.1868 20.6479 23.4799 20.3549C23.7729 20.0618 23.9375 19.6644 23.9375 19.25V16.125C23.9375 15.9178 23.8552 15.7191 23.7087 15.5726C23.5622 15.4261 23.3635 15.3437 23.1562 15.3437C22.5346 15.3437 21.9385 15.0968 21.499 14.6573C21.0594 14.2177 20.8125 13.6216 20.8125 13C20.8125 12.3784 21.0594 11.7823 21.499 11.3427C21.9385 10.9032 22.5346 10.6562 23.1562 10.6562ZM3.625 16.8281C4.50804 16.6488 5.30193 16.1697 5.87217 15.4721C6.44241 14.7744 6.75392 13.9011 6.75392 13C6.75392 12.0989 6.44241 11.2256 5.87217 10.5279C5.30193 9.83026 4.50804 9.35118 3.625 9.17188V6.75H9.09375V19.25H3.625V16.8281Z"
                  fill="white"
                />
              </svg>
            </Box>
          </HStack>
          <Button variant="outline" w="full" rounded="full" onClick={onClose}>
            Close
          </Button>
        </VStack>
      </DialogBody>
    </DialogContent>
  );
};
